var render = function render(){var _vm=this,_c=_vm._self._c;return _c('auth-layout',{attrs:{"pageClass":"login-page"}},[_c('div',{staticClass:"row d-flex justify-content-center align-items-center"},[_c('div',{staticClass:"col-lg-4 col-md-6 col-sm-8"},[_vm._v(" ... Please Wait ... ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }